module.exports = __webpack_public_path__ + "img/logo.fa450e0a.png";